export const evaluationCriteriaStyle = {
    formControlRoot: {
        display: 'flex',
        paddingRight: '10px',
        margin: 0
    },
    formGroup: {
        display: 'grid',
        justifyContent: 'space-between',
        gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))',
        minWidth: '450px', // Make it responsive by setting width to 100%
        gap: '0px 10px',
        padding: 0,

        //   paddingRight: '30px' // Right padding
    },
    checkbox: {
        // color: 'blue',
        '&$checked': {
            color: '#004894',
            margin: '0px',
            backgroundColor: 'transparent',
            //   height: '18px',
            //   width: '18px',
            borderRadius: '4px',
        }, '&:hover': {
            backgroundColor: 'transparent', // Prevent background color change on hover
        },
    },
    checked: {},
    formLabel: {
        color: '#0B0C0C',
        fontSize: '13px',
        width: "100%",
        fontFamily: 'Roboto',
        fontWeight: '400',
        lineHeight: '20px',
        '&:hover': {
            backgroundColor: 'transparent', // Prevent background color change on hover
        },
    },
    formLabelWrap: {
        // margin: '0px',
        display: 'flex',
        marginRight: '5px',
        // width: '140px',
        wordWrap: 'break-word',
        marginTop: 0,
        marginBottom: 0
    }
}